export default __webpack_public_path__ + "static/media/Group 3377@2x.72e451c9.png";